export enum Region {
  GL = "GL",
  JP = "JP",
}
